import { render, staticRenderFns } from "./RmsEquip.vue?vue&type=template&id=90cf6f16&scoped=true&"
import script from "./RmsEquip.vue?vue&type=script&lang=js&"
export * from "./RmsEquip.vue?vue&type=script&lang=js&"
import style0 from "./RmsEquip.vue?vue&type=style&index=0&id=90cf6f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cf6f16",
  null
  
)

component.options.__file = "RmsEquip.vue"
export default component.exports